// extracted by mini-css-extract-plugin
export default {"wrapper":"faq_wrapper__egm-R","heading":"faq_heading__mwtlF"};